export default __webpack_public_path__ + "static/media/undraw_Processing_re_tbdu.68c95fbd.svg";